import { useEffect } from 'react';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import {
  Navigate,
  Outlet,
  useLocation
} from 'react-router-dom';

import LinearProgress from '@mui/material/LinearProgress';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  loading: {
    width: '100%',
    height: '4px',
    zIndex: 1201,
    position: 'fixed'
  }
}));

/**
 * Redirect loading indicator
 *
 * @returns {Element}
 */
const Loading = () => {
  const classes = useStyles();
  return (
    <LinearProgress className={classes.loading} />
  );
};

export default function Authenticated({ children }) {
  const { authenticated, login, accountUuid } = useAuthentication();
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (authenticated) return;
    login(`${pathname}${search}`);
  }, [pathname, search, authenticated, login]);

  if (authenticated) {
    if (!accountUuid) {
      return (<Navigate to="/d/account-not-found/" />);
    }
    return children || <Outlet />;
  }

  return (
    <Loading />
  );
}
